import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, FileText, GraduationCap, Image as ImageIcon, Inbox, Layers, Users } from "lucide-react";
import { adminApi, fmtDate } from "./api";

const CARDS = [
  { key: "consultations", label: "Consultations", icon: Inbox, to: "/admin/submissions" },
  { key: "careers", label: "Career Applications", icon: Briefcase, to: "/admin/submissions" },
  { key: "internships", label: "Internships", icon: GraduationCap, to: "/admin/submissions" },
  { key: "team", label: "Team Members", icon: Users, to: "/admin/team-services" },
  { key: "services", label: "Services", icon: Layers, to: "/admin/team-services" },
  { key: "media", label: "Media Assets", icon: ImageIcon, to: "/admin/media" },
];

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => setError(true));
  }, []);

  if (error) return <p className="admin-error" data-testid="dashboard-error">Could not load the dashboard. Please refresh.</p>;
  if (!data) return <p className="admin-loading" data-testid="dashboard-loading">Loading dashboard…</p>;

  return (
    <div data-testid="admin-dashboard">
      <div className="admin-page-head">
        <h1>Dashboard</h1>
        <p>An operational overview of your website.</p>
      </div>
      <div className="dash-grid">
        {CARDS.map((c) => (
          <Link to={c.to} className="dash-card" key={c.key} data-testid={`dash-card-${c.key}`}>
            <c.icon size={19} />
            <strong data-testid={`dash-count-${c.key}`}>{data.counts[c.key]}</strong>
            <span>{c.label}</span>
          </Link>
        ))}
      </div>
      <div className="dash-columns">
        <section className="admin-panel">
          <h2><Inbox size={16} /> Recent consultation requests</h2>
          {data.recent_submissions.length === 0 && <p className="empty-note">No submissions yet.</p>}
          {data.recent_submissions.map((s) => (
            <div className="dash-row" key={s.id} data-testid="dash-recent-submission">
              <div><strong>{s.name}</strong><span>{s.requirement_type}</span></div>
              <time>{fmtDate(s.created_at)}</time>
            </div>
          ))}
          <Link to="/admin/submissions" className="text-link" data-testid="dash-all-submissions-link">View all submissions</Link>
        </section>
        <section className="admin-panel">
          <h2><FileText size={16} /> Recently updated content</h2>
          {data.recent_content.length === 0 && <p className="empty-note">No content edits yet. Open the Content Editor to make your first change.</p>}
          {data.recent_content.map((cItem) => (
            <div className="dash-row" key={cItem.key} data-testid="dash-recent-content">
              <div><strong>{cItem.label}</strong><span>{cItem.page} page · by {cItem.updated_by}</span></div>
              <time>{fmtDate(cItem.updated_at)}</time>
            </div>
          ))}
          <Link to="/admin/content" className="text-link" data-testid="dash-content-editor-link">Open Content Editor</Link>
        </section>
      </div>
    </div>
  );
}
